import { ENDPOINT_PROFILE } from '../config'
import type { ProfileResponse, UpdateProfileParams } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Update current user's profile information
 */
const updateProfile = async (
  params: UpdateProfileParams,
): Promise<ProfileResponse> => {
  const response = await AuthAxios.put<ProfileResponse>(
    ENDPOINT_PROFILE,
    params
  )
  return response.data
}

export default updateProfile
